import { ApiClient } from '@restaurant/api-client'
import { readToken } from '../stores/token-storage'

/**
 * Uygulamanın tek HTTP katmanı.
 *
 * Doğrudan `fetch` kullanımı yasaktır: korelasyon kimliği, idempotency
 * anahtarı ve hata sınıflandırması yalnızca burada garanti edilir
 * (`packages/api-client`).
 */
export const api = new ApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8080',
  getToken: () => readToken() ?? undefined,
})
